import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* 頁面標題區 */}
      <div className="bg-gradient-to-br from-emerald-50 to-white py-20 mt-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            隱私權政策
          </h1>
          <p className="text-lg text-gray-600">
            朋睿國際策略管理顧問股份有限公司網站之個人資料保護政策
          </p>
        </div>
      </div>

      {/* 文章內容區 */}
      <div className="max-w-[900px] mx-auto px-6 lg:px-8 py-16">
        <article className="prose prose-lg max-w-none">
          <div className="space-y-8 text-gray-700 leading-relaxed" style={{ lineHeight: '1.6' }}>
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">隱私權政策</h2>
              <p className="text-sm text-gray-500 mt-2.5 mb-5">
                最後更新日期：2026 年 2 月 23 日
              </p>
              <p className="mb-5">
                親愛的客戶您好，歡迎蒞臨「朋睿國際策略管理顧問股份有限公司網站」（以下簡稱「朋睿網站」）。為了尊重與保護您的個人隱私權，本公司特制定隱私權保護政策，說明在您使用朋睿網站及其延伸服務時，朋睿網站如何蒐集、處理及運用您的個人資料，敬請詳細閱讀。
              </p>
              <p className="mb-5">
                朋睿網站適用於所有透過本公司官方網站所提供之服務及互動行為。若您連結至其他第三方網站，該等網站的資料處理方式將依其隱私權政策為準，本公司不負相關責任。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">資料蒐集目的</h2>
              <p className="mb-5">
                為提供完善的顧問服務及網站體驗，除一般訪客瀏覽外，若您選擇註冊會員或使用會員專屬服務，朋睿網站可能蒐集個人資料以提供以下服務：資訊傳達、電子報或電子DM發送、線上報名課程或活動、掌握最新業務動態及會員專屬優惠活動。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">資料蒐集方式</h2>
              <p className="mb-5">
                在使用朋睿網站會員專屬服務時，會蒐集並保留您提供的姓名、電子郵件、電話、公司名稱、職稱或其他必要資訊，或您在使用過程中所產生的資料。
              </p>
              <p className="mb-5">
                註冊成為會員時，可能需要提供姓名、電子郵件、聯絡電話、行動電話、職稱、任職公司及部門名稱等資料，以便辨識您的身份並提供會員專屬服務。
              </p>
              <p className="mb-5">
                在您瀏覽網站時，朋睿網站會自動記錄伺服器生成的瀏覽紀錄，例如瀏覽頁面、停留時間及訪問次數等，用於內部分析及改善網站服務品質，該資料不會對外公開。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">資料保密性與安全性</h2>
              <p className="mb-5">
                朋睿網站承諾遵守《個人資料保護法》規定，妥善保護您的個人資料。未經授權，本公司不會將您的資料揭露、販售或提供給與服務無關之第三方。
              </p>
              <p className="mb-5">
                網站伺服器設有防火牆、防毒系統及其他必要的安全防護措施，僅授權人員方能接觸個人資料，並負有保密義務，確保資料安全。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">使用者權益</h2>
              <p className="mb-5">
                若您不希望再收到任何活動訊息或行銷資訊，可透過電子郵件通知我們（客服信箱：<a href="mailto:contact@psfcapital.tw" className="text-emerald-600 hover:text-emerald-700 cursor-pointer">contact@psfcapital.tw</a>），本公司將在您的個人資料上加註，停止運用於行銷活動。
              </p>
              <p className="mb-5">
                您可隨時請求查詢、閱覽、補充、更正或刪除於朋睿網站所留下的個人資料。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">政策修訂</h2>
              <p className="mb-5">
                朋睿網站將不定期更新隱私權政策，並於政策頁面及網站公告最新版本。建議您定期查閱本政策，了解我們如何保護個人資訊。持續使用網站服務，即表示您同意本政策及其更新內容。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">問題與建議</h2>
              <p className="mb-5">
                如對本隱私權政策或個人資料使用有任何疑問，歡迎透過電子郵件與我們聯繫：
              </p>
              <p className="mb-5">
                客服信箱：<br />
                <a href="mailto:contact@psfcapital.tw" className="text-emerald-600 hover:text-emerald-700 cursor-pointer">contact@psfcapital.tw</a>
              </p>
            </section>

          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}